import { render, staticRenderFns } from "./labCertificateBox.vue?vue&type=template&id=14be6eaf"
import script from "./labCertificateBox.vue?vue&type=script&lang=js"
export * from "./labCertificateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports